import { FieldType } from './FieldType';

export const FieldTypeOptions = [
    {
        id: FieldType.AlphaNumeric,
        name: 'AlphaNumeric',
    },
    {
        id: FieldType.Currency,
        name: 'Currency',
    },
    {
        id: FieldType.Date,
        name: 'Date',
    },
    {
        id: FieldType.Decimal,
        name: 'Decimal',
    },
    {
        id: FieldType.Integer,
        name: 'Integer',
    },
    {
        id: FieldType.Lookup,
        name: 'Lookup',
    },
    {
        id: FieldType.ZipCode,
        name: 'ZipCode',
    },
    {
        id: FieldType.DecimalSinglePrecision,
        name: 'DecimalSinglePrecision',
    },
];
